<template>
	<lcsj-dialog v-model="showDialog" title="创建销售订单提成" width="80%" @close="closeDialog" cancel-text="关闭">
		<template #footer>
			<div class="dialog-footer">
				<el-button size="small" @click="closeDialog">关闭</el-button>
				<el-button size="small" type="primary" @click="handleCreateSalesOrderCommission">创建销售订单提成</el-button>
			</div>
		</template>

		<detail ref="detail"></detail>
		<div v-loading="loading" class="item_info" element-loading-text="加载中...">
			<el-descriptions class="margin-top" title="提成信息" :column="5" border>
				<el-descriptions-item label="销售提成员工" span="3">
					<el-select v-model="commissionInfo.employeeKeyIds" name="employeeKeyIds" multiple placeholder="请选择员工" style="width: 100%" filterable clearable>
						<el-option v-for="item in employeeList" :key="item.keyId" :label="item.value" :value="item.keyId" />
					</el-select>
				</el-descriptions-item>
				<el-descriptions-item label="是否电话提成">{{ salesOrderInfo.phonePnvitation ? "有" : "无" }}</el-descriptions-item>
				<el-descriptions-item label="电话提成员工" v-if="commissionInfo.isPhoneBonus">{{ salesOrderInfo.phonePnvitationName ? salesOrderInfo.phonePnvitationName : "无" }}</el-descriptions-item>
			</el-descriptions>
		</div>
		
	</lcsj-dialog>
</template>
<script>
import { CreateSalesOrderCommission, GetSalesOrderDetail } from "@/api/productApi.js";
import detail from "@/views/product/sales/detail.vue";
import { GetUserBindSelectByPermission } from "@/api/userApi.js";
export default {
	props: [],
	data() {
		return {
			showDialog: false,
			loading: false,
			commissionInfo: {
				keyId: "",
				employeeKeyIds: [],
				isPhoneBonus: false,
				phoneEmlpoyeeKeyId: ""
			},
			storeKeyId: "",
			employeeList: [],
			phoneEmployeeList: [],
			salesOrderInfo: {}
		};
	},
	components: {
		detail
	},
	created() {},
	methods: {
		// 显示
		getCreateCommissionDialog(row) {
			// 清空上一次的数据，显示加载中
			this.resetData();
			this.loading = true;
			this.showDialog = true;
			this.$nextTick(() => {
				this.$refs.detail.getDetail(row);
			});
			this.storeKeyId = row.storeKeyId;
			this.commissionInfo.keyId = row.keyId;
			// 获取员工列表
			this.getEmployeeList();
			// 获取销售订单详情
			this.getSalesOrderDetail();
		},
		// 重置展示数据（打开弹窗/切换数据时清空旧内容）
		resetData() {
			this.commissionInfo = {
				keyId: "",
				employeeKeyIds: [],
				isPhoneBonus: false,
				phoneEmlpoyeeKeyId: ""
			};
			this.storeKeyId = "";
			this.salesOrderInfo = {};
		},
		// 关闭
		closeDialog() {
			this.commissionInfo.isPhoneBonus = false;
			this.commissionInfo.phoneEmlpoyeeKeyId = "";
			this.commissionInfo.employeeKeyIds = [];
			this.showDialog = false;
		},
		// 确认创建销售订单提成
		handleCreateSalesOrderCommission() {
			if (this.commissionInfo.employeeKeyIds == null || this.commissionInfo.employeeKeyIds == undefined || this.commissionInfo.employeeKeyIds.length == 0) {
				this.$message({
					type: "error",
					message: "请选择充卡提成员工！"
				});
				return;
			}
			if (this.commissionInfo.isPhoneBonus) {
				if (this.commissionInfo.phoneEmlpoyeeKeyId == "" || this.commissionInfo.phoneEmlpoyeeKeyId == null || this.commissionInfo.phoneEmlpoyeeKeyId == undefined) {
					this.$message({
						type: "error",
						message: "请选择电话提成员工！"
					});
					return;
				}
			}
			this.$confirm("确定创建销售订单提成吗？", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			})
				.then(() => {
					CreateSalesOrderCommission(this.commissionInfo)
						.then((res) => {
							if (res.code == 1) {
								this.$message({
									type: "success",
									message: "创建销售订单提成成功！"
								});
								setTimeout(() => {
									this.$parent.getListData();
									this.showDialog = false;
								}, 1500);
							} else {
								this.$message.error(res.msg);
							}
						})
						.catch((err) => {
							this.$message.error("创建销售订单提成失败，请稍后再试！");
						});
				})
				.catch(() => {
					this.$message({
						type: "info",
						message: "已取消创建销售订单提成"
					});
				});
		},
		// 获取员工列表
		getEmployeeList() {
			GetUserBindSelectByPermission({
				keyId: this.storeKeyId,
				isChargePerson: true
			}).then((res) => {
				if (res.code == 1) {
					this.employeeList = res.data;
					this.phoneEmployeeList = res.data;
				} else {
					this.$message({
						type: "error",
						message: res.msg
					});
				}
			});
		},
		// 获取销售订单详情
		getSalesOrderDetail() {
			GetSalesOrderDetail({
				keyId: this.commissionInfo.keyId
			})
				.then((res) => {
					if (res.code == 1) {
						this.salesOrderInfo = res.data;
						if (this.salesOrderInfo.phonePnvitation) {
							this.commissionInfo.isPhoneBonus = true;
							this.commissionInfo.phoneEmlpoyeeKeyId = this.salesOrderInfo.phonePnvitation;
						} else {
							this.commissionInfo.isPhoneBonus = false;
							this.commissionInfo.phoneEmlpoyeeKeyId = "";
						}
					} else {
						this.$message({
							type: "error",
							message: res.msg
						});
					}
				})
				.finally(() => {
					this.loading = false;
				});
		}
	}
};
</script>
<style scoped lang="scss">
.main_bg {
	padding: 10px;
	margin-top: -15px;
}

.item_info {
	border-left: 5px solid var(--app-primary-hover);
	padding: 5px 10px;
	border-radius: 5px;
	margin-bottom: 15px;
	border-bottom: 2px solid var(--app-border);
}

.border_Warningcolor {
	border-left: 5px solid var(--app-warning);
}

.border_Green {
	border-left: 5px solid var(--app-success);
}

.border_Danger {
	border-left: 5px solid var(--app-danger);
}

.item_title {
	display: flex;
	width: 100%;
	font-weight: 700;
	font-size: 1rem;
	margin-bottom: 10px;
	justify-content: space-between;

	.title {
		display: inline-block;
		unicode-bidi: isolate;
	}

	.btnDiv {
		display: block;
		unicode-bidi: isolate;
		word-break: break-all;
	}

	.btnDivItem {
		display: inline-block;
	}

	.text-red {
		display: block;
		background-color: var(--app-danger);
	}
}
</style>
